export function addUtm<TValue extends string | URL>(
  urlOrPath: TValue,
  utmParams: Record<string, string> | URLSearchParams | null,
): TValue {
  if (!utmParams) return urlOrPath;

  const params = new URLSearchParams(utmParams);

  if (typeof urlOrPath === "string") {
    const url = new URL(urlOrPath, "https://example.com");
    for (const [key, value] of params) url.searchParams.set(key, value);
    return (url.pathname + url.search) as TValue;
  }

  if (typeof urlOrPath === "object" && urlOrPath instanceof URL) {
    const url = new URL(urlOrPath as URL);
    for (const [key, value] of params) url.searchParams.set(key, value);
    return url as TValue;
  }

  throw new Error("Unable to add utm to url");
}
